<template>
  <template v-if="hasRandomReward">
    <div
      class="profile-mission-random p-2"
      data-test="profile-mission-random-panel"
    >
      <OpenBox
        :countList="getRewardList"
        :getRewardList="getRewardList"
        :point_total="$store.state.shortProfile.total_point || 0"
        @goToMission="goToMission"
        mission
      />
    </div>
  </template>
  <div
    v-else
    class="profile-mission-reward-panel border-none overflow-hidden"
    elevation="0"
    data-test="profile-mission-panel"
  >
    <div class="profile-mission-header">
      <div class="f-lg f-bold line-clamp-2" data-test="profile-mission-title">
        {{ detail.data.name }}
      </div>
      <div
        class="f-md f-bold text-nowrap"
        data-test="profile-mission-progress-text"
      >
        {{ progressText }}
      </div>
    </div>

    <!-- <pre>{{ visibleStamps }}</pre> -->
    <div v-if="isStampMission" class="profile-mission-stamp-grid">
      <template
        v-for="(stamp, index) in visibleStamps"
        :key="stamp.id || index"
      >
        <button
          v-if="getGiftReward(index)"
          type="button"
          class="profile-mission-stamp-btn"
          :data-test="`profile-mission-stamp-gift-btn-${index}`"
          @click="showStamp(stamp)"
        >
          <c-img
            class="profile-mission-stamp-img"
            :src="giftStampImage(getGiftReward(index))"
            data-test="profile-mission-stamp-gift-img"
          ></c-img>
        </button>
        <button
          v-else-if="stamp.transaction_id != 0"
          type="button"
          class="profile-mission-stamp-btn"
          :data-test="`profile-mission-stamp-success-btn-${index}`"
          @click="showStamp(stamp)"
        >
          <c-img
            class="profile-mission-stamp-img"
            :src="$store.state.domain + $store.state.theme.mission_success_icon"
            data-test="profile-mission-stamp-success-img"
          ></c-img>
        </button>
        <button
          v-else-if="
            detail.data.is_show_only_have_stamp == 0 ||
            detail.stamp_success == index
          "
          type="button"
          class="profile-mission-stamp-btn"
          :data-test="`profile-mission-stamp-pending-btn-${index}`"
          @click="showStamp(stamp)"
        >
          <c-img
            class="profile-mission-stamp-img"
            :src="
              $store.state.domain + $store.state.theme.mission_unsuccess_icon
            "
            data-test="profile-mission-stamp-pending-img"
          ></c-img>
        </button>
      </template>
    </div>

    <div v-else class="px-3 pb-3" data-test="profile-mission-spending-panel">
      <div class="content-between f-sm mb-2">
        <span>{{ spendingLabel }}</span>
        <span class="color-primary f-bold">{{ progressText }}</span>
      </div>
      <v-progress-linear
        color="custom-primary"
        :model-value="detail.user_spending"
        :max="detail.data.mission_redeem_goal"
        height="5"
        rounded
        data-test="profile-mission-progress-bar"
      ></v-progress-linear>
    </div>

    <div class="text-center" v-if="canToggleReward">
      <c-btn
        class="color-primary f-bold f-md"
        variant="custom-link"
        @click="toggleReward"
        data-test="profile-mission-stamp-toggle-btn"
      >
        <span v-if="expandRewards">
          Show Less
          <font-awesome-icon size="sm" icon="chevron-up" class="color-gray" />
        </span>
        <span v-else>
          Show More
          <font-awesome-icon size="sm" icon="chevron-down" class="color-gray" />
        </span>
      </c-btn>
    </div>

    <!-- <hr class="my-0" /> -->

    <div
      v-if="visibleRewards.length > 0"
      class="p-3"
      data-test="profile-mission-reward-list"
    >
      <div class="content-between mb-2">
        <div class="f-md f-bold" data-lang="mission_reward">
          {{ $t("mission_reward") }}
        </div>
      </div>

      <template v-if="redeemableRewards.length > 0">
        <div
          v-for="(items, index) in visibleRewards"
          :key="items.id"
          class="profile-mission-reward-item"
          :data-test="`profile-mission-reward-item-${items.id}`"
        >
          <div class="profile-mission-reward-row">
            <c-img
              :src="rewardImage(items)"
              class="profile-mission-reward-img"
              @error="handleImageSrc"
              data-test="profile-mission-reward-img"
            ></c-img>
            <div class="profile-mission-reward-content">
              <div class="f-bold line-clamp-2">
                <span v-if="items.mission_detail_type_id == 3">
                  {{ items.redeem_target_id }} {{ $t("currency_unit") }}
                </span>
                <span v-else>{{ items.name }}</span>
              </div>
              <div class="f-sm text-gray">
                <span v-if="detail.data.mission_redeem_type == 1">
                  {{ $t("spending") }} {{ numeralFormat(items.when_reach) }}
                  {{ $t("currency_unit") }}
                </span>
                <span v-else-if="detail.data.mission_redeem_type == 2">
                  {{ $t("stamp_collect") }} {{ items.when_reach }}
                  {{ $t("stamp") }}
                </span>
                <span v-else>
                  {{ $t("collect_point") }}
                  {{ numeralFormat(items.when_reach) }}
                </span>
              </div>

              <div class="mt-1">
                <template v-if="items.is_redeem == 0">
                  <c-btn
                    variant="primary-theme"
                    pill
                    class="f-sm py-1"
                    :disabled="!canRedeem(items) || items.redeem_status == 0"
                    @click.stop="redeemItemsConfirm(items)"
                    :data-test="`profile-mission-reward-redeem-btn-${items.id}`"
                  >
                    <span data-lang="get_reward">{{ $t("get_reward") }}</span>
                  </c-btn>
                </template>

                <div
                  v-else-if="
                    items.is_redeem == 1 &&
                    items.mission_detail_type_id != 1 &&
                    items.random_reward_type != 1
                  "
                  class="f-sm text-gray"
                  data-test="profile-mission-reward-redeemed-msg"
                >
                  <span data-lang="get_reward">{{ $t("get_reward") }}</span>
                  {{ $moment(items.redeem_date).format("DD MMM YYYY HH:mm") }}
                  <font-awesome-icon icon="check-circle" class="text-success" />
                </div>

                <div
                  v-else-if="
                    (items.mission_detail_type_id == 1 ||
                      items.random_reward_type == 1) &&
                    (items.pick_up_type == 1 ||
                      items.random_pick_up_type == 1) &&
                    items.branch_id == 0
                  "
                  class="f-sm text-gray bg-primary-light rounded-lg p-2"
                  @click.stop="redeemBranchItems(items)"
                  :data-test="`profile-mission-reward-branch-btn-${items.id}`"
                >
                  <v-badge
                    color="warning"
                    class="f-sm"
                    inline
                    content="รอกรอกข้อมูล"
                  ></v-badge>
                  <div class="text-black mt-2">
                    กรุณาเลือกสาขาที่ต้องการรับสินค้า
                  </div>
                </div>

                <div
                  v-else-if="
                    (items.pick_up_type == 1 ||
                      items.random_pick_up_type == 1) &&
                    items.is_redeem == 1 &&
                    items.branch_id != 0
                  "
                  class="f-sm text-gray bg-primary-light rounded-lg p-2"
                  data-test="profile-mission-reward-branch-msg"
                >
                  <v-badge
                    :color="textStatus(items.mission_order_status)"
                    class="f-sm"
                    inline
                    :content="items.mission_order_status"
                  ></v-badge>
                  <div class="text-black mt-2">{{ items.branch_name }}</div>
                </div>

                <div
                  v-else
                  class="f-sm text-gray bg-primary-light rounded-lg p-2"
                  @click.stop="handleAddress(items)"
                  :data-test="`profile-mission-reward-address-btn-${items.id}`"
                >
                  <v-badge
                    pill
                    inline
                    :color="textStatus(items.mission_order_status)"
                    size="lg"
                    class="f-sm"
                    :content="items.mission_order_status"
                  ></v-badge>
                  <p
                    class="f-sm mb-0"
                    v-if="items.mission_order_status != 'รอกรอกข้อมูล'"
                  >
                    <b>
                      {{ $store.state.shortProfile.first_name_th }}
                      {{ $store.state.shortProfile.last_name_th }}
                      {{ $store.state.shortProfile.telephone }}
                    </b>
                    <span v-html="displayAddress(items)"></span>
                  </p>
                  <div class="text-black mt-2 f-sm" v-else>
                    กรุณากรอกข้อมูลการจัดส่ง
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr v-if="index != visibleRewards.length - 1" />
        </div>
        <!-- 
        <div class="text-center mt-2" v-if="canToggleReward">
          <c-btn
            class="color-primary f-bold f-md"
            variant="custom-link"
            @click="toggleReward"
            data-test="profile-mission-reward-toggle-btn"
          >
            <span v-if="expandRewards">
              Show Less
              <font-awesome-icon
                size="sm"
                icon="chevron-up"
                class="color-gray"
              />
            </span>
            <span v-else>
              Show More
              <font-awesome-icon
                size="sm"
                icon="chevron-down"
                class="color-gray"
              />
            </span>
          </c-btn>
        </div> -->
      </template>
      <div
        v-else
        class="text-center text-gray"
        data-test="profile-mission-reward-empty"
      >
        {{ $t("no_data") }}
      </div>
    </div>

    <StampModal
      ref="StampModal"
      :text="msg"
      @hide="hideSuccess"
      :stampCondition="stampCondition"
      :stampProduct="stampProduct"
      closeText="ปิดหน้าต่างนี้"
    />
    <ModalConfirm
      ref="redeemConfirmModal"
      :header="confirmRedeem.header"
      :text="confirmRedeem.text"
      :subText="confirmRedeem.subText"
      :button="confirmRedeem.button"
      @handler="useCoupon"
    />
    <ModalSelectBranch
      ref="ModalSelectBranch"
      :branch="branchList"
      @showPointUsedModal="updateRedeemItems"
    />
    <ModalLoading ref="modalLoading" />
    <ModalError ref="modalError" :text="msg" />
    <v-dialog
      v-model="successUpdateModal"
      data-test="profile-mission-success-modal"
      hide-header
      hide-footer
      centered
      no-close-on-backdrop
      no-close-on-esc
      body-class="p-0"
    >
      <div class="my-3 text-center">
        <div class="f-bold f-xl">แลกของรางวัลเสร็จสิ้น</div>
        <div
          class="content-description p-3"
          v-if="rewardItems.mission_order_status == 'รับที่ร้านค้า'"
        >
          ขอบคุณสำหรับการร่วมกิจกรรมและแลกของรางวัลกับทาง
          {{ $BRAND }}
        </div>
      </div>
      <div class="px-3 mb-3 text-center">
        <v-row>
          <v-col>
            <c-btn
              @click="successUpdateModal = false"
              variant="confirm-primary"
              block
              data-test="profile-mission-success-modal-close-btn"
            >
              ปิดหน้าต่างนี้
            </c-btn>
          </v-col>
        </v-row>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import ModalConfirm from "@/components/alert-modal/ModalConfirm.vue";
import ModalError from "@/components/alert-modal/ModalError";
import ModalLoading from "@/components/other/ModalLoading.vue";
import ModalSelectBranch from "@/components/reward/modal/ModalSelectBranch";
import StampModal from "@/views/page/mission/components/StampModal.vue";
import OpenBox from "@/views/page/transaction/detail";

export default {
  name: "ProfileMissionRewardPanel",
  components: {
    ModalConfirm,
    ModalError,
    ModalLoading,
    ModalSelectBranch,
    OpenBox,
    StampModal
  },
  props: {
    detail: {
      type: Object,
      required: true
    }
  },
  emits: ["refresh"],
  data() {
    return {
      branchList: [],
      confirmRedeem: {
        header: this.$t("confirm_used"),
        text: "",
        subText: "",
        button: {
          true: {
            class: ["btn-danger"],
            msg: this.$t("confirm")
          },
          false: {
            class: ["btn-secondary"],
            msg: this.$t("cancel")
          }
        }
      },
      getRewardList: [],
      expandRewards: true,
      hasRandomReward: false,
      isStampExpanded: false,
      msg: "",
      rewardItems: { id: 0 },
      stampCondition: {},
      stampProduct: [],
      successUpdateModal: false
    };
  },
  computed: {
    canToggleReward() {
      return this.redeemableRewards.length > 0;
    },
    canToggleStamp() {
      return this.isStampMission && (this.detail.stamp || []).length > 10;
    },
    isStampMission() {
      return this.detail.data.mission_redeem_type == 2;
    },
    missionId() {
      return this.detail.data.user_mission_id || this.$route.params.id;
    },
    progressText() {
      if (this.isStampMission) {
        const current = this.detail.stamp_success || 0;
        if (this.detail.data.is_show_only_have_stamp == 1) {
          return `${current} สำเร็จ`;
        }
        return `${current}/${this.detail.stamp_count || 0} สำเร็จ`;
      }

      const current =
        this.detail.user_spending >= this.detail.data.mission_redeem_goal
          ? this.detail.data.mission_redeem_goal
          : this.detail.user_spending;
      return `${this.numeralFormat(current)}/${this.numeralFormat(
        this.detail.data.mission_redeem_goal
      )}`;
    },
    redeemableRewards() {
      return (this.detail.reward || []).filter(el => el.status == 1);
    },
    spendingLabel() {
      return this.detail.data.mission_redeem_type == 3
        ? this.$t("total_collect_point")
        : this.$t("total_spend_unit");
    },
    visibleRewards() {
      if (this.expandRewards) return this.redeemableRewards;
      return this.redeemableRewards.slice(0, 0);
    },
    visibleStamps() {
      return this.detail.stamp;
    }
  },
  methods: {
    canRedeem(items) {
      if (this.detail.data.mission_redeem_type == 2) {
        return items.when_reach <= this.detail.stamp_success;
      }
      return items.when_reach <= this.detail.user_spending;
    },
    async getBranch() {
      try {
        this.$refs.modalLoading.show();
        this.$axios
          .get(
            `/api/v1/Reward/redeem_coupon/${this.rewardItems.branch_group_id}`
          )
          .then(async data => {
            const branchList = [];
            for (const { branch } of data.detail) {
              const temp = branch.filter(x => x.is_check);
              branchList.push(...temp);
            }

            this.branchList = branchList;
            this.$refs.modalLoading.hide();
            this.$refs.ModalSelectBranch.show();
          })
          .catch(error => {
            this.$logger({
              response: {
                config: {
                  url: "/api/v1/Reward/redeem_coupon/0",
                  method: "GET"
                }
              },
              action: {
                action: "modal select profile mission branch",
                id: 3,
                note: error.toString()
              }
            });
          });
      } catch (error) {
        this.$logger({
          response: {
            config: { url: "/api/v1/Reward/redeem_coupon/0", method: "GET" }
          },
          action: {
            action: "modal select profile mission branch",
            id: 3,
            note: error.toString()
          }
        });
      }
    },
    getGiftReward(index) {
      console.log(index + 1);
      return (
        this.redeemableRewards.find(r => r.when_reach == index + 1) || null
      );
    },
    giftStampImage(reward) {
      console.log(reward);
      if (reward.is_redeem == 1)
        return require("@/assets/images/stamp/Gift_BA-Active_yellow.png");
      console.log();
      if (this.detail.stamp_success < reward.when_reach) {
        return require("@/assets/images/stamp/Gift BA-Inactive.png");
      }
      return require("@/assets/images/stamp/Gift_BA-Inactive_yellow.png");
      // E:\work\clarins-crm-line-liff\src\assets\images\stamp\Gift BA-Inactive.png
      // E:\work\clarins-crm-line-liff\src\assets\images\stamp\Gift_BA-Active_yellow.png
      // E:\work\clarins-crm-line-liff\src\assets\images\stamp\Gift_BA-Inactive_yellow.png
      // return require("@/assets/images/stamp/Gift_BA-Inactive_yellow.png");
    },
    goToMission() {
      this.hasRandomReward = false;
      this.$emit("refresh");
    },
    handleAddress(items) {
      if (
        (items.mission_detail_type_id == 1 || items.random_reward_type == 1) &&
        (items.pick_up_type == 2 || items.random_pick_up_type == 2) &&
        items.mission_order_status == "รอกรอกข้อมูล"
      ) {
        return this.$router.replace(
          `/mission-info/address/${items.mission_detail_id}/${this.missionId}?selectBranch=${this.detail.data.mission_detail_type_id}`
        );
      }
    },
    hideSuccess() {},
    redeemBranchItems(items) {
      items.user_mission_id = this.detail.data.user_mission_id;
      this.rewardItems = items;
      this.getBranch();
    },
    async redeemItems(branch_id) {
      const payload = {
        ...this.rewardItems,
        branch_id: branch_id || 0,
        user_mission_detail_id: this.rewardItems.id
      };

      try {
        this.$refs.modalLoading.show();
        if (this.rewardItems.mission_detail_type_id == 5) {
          const res = await this.$axios.post(
            `/api/RandomReward/GetRandomReward`,
            {
              random_reward_id: this.rewardItems.redeem_target_id,
              mission_id: this.missionId,
              user_mission_stamp_detail_id: payload.user_mission_detail_id,
              user_mission_id: this.rewardItems.user_mission_id,
              mission_detail_id: this.rewardItems.mission_detail_id
            }
          );
          if (res.result == 1) {
            if (!res.detail.have_random_reward) {
              this.$refs.modalLoading.hide();
              this.msg = "ไม่พบของรางวัล";
              return this.$refs.modalError.show();
            }
            this.hasRandomReward = true;
            this.getRewardList = res.detail.random_reward.sort(
              (a, b) => a.id - b.id
            );
          } else {
            this.msg = res.message;
            this.$refs.modalError.show();
          }

          this.$refs.modalLoading.hide();
        } else {
          const res = await this.$axios.post(
            "/api/v1/Mission/RedeemReward",
            payload
          );
          this.$refs.modalLoading.hide();
          if (res.result == 1) {
            this.$refs.ModalSelectBranch.close();
            if (this.rewardItems.is_redeem == 1) {
              this.$emit("refresh");
              return (this.successUpdateModal = true);
            }
            this.$router.push(
              `/mission-info/${this.rewardItems.mission_detail_id}/${this.missionId}`
            );
          } else {
            this.msg = res.message;
            this.$refs.modalError.show();
          }
        }
      } catch (error) {
        this.msg = error.message;
        this.$logger({
          response: {
            config: { url: "/api/v1/Mission/RedeemReward", method: "POST" }
          },
          action: { action: "redeem profile mission error", id: 3 }
        });
        this.$refs.modalError.show();
        this.$refs.modalLoading.hide();
      }
    },
    redeemItemsConfirm(items) {
      if (
        this.$moment().diff(
          this.$moment(this.detail.data.valid_to),
          "minutes"
        ) > 0
      ) {
        this.msg = "ขออภัยไม่สามารถรับรางวัลได้, เนื่องจาก Mission หมดอายุแล้ว";
        return this.$refs.modalError.show();
      }
      if (
        this.$moment().diff(
          this.$moment(this.detail.data.valid_from),
          "minutes"
        ) < 0
      ) {
        this.msg = `สามารถแลกสินค้าได้วันที่ ${this.$moment(
          this.detail.data.valid_from
        ).format("DD MMMM YYYY (HH:mm)")}`;
        return this.$refs.modalError.show();
      }
      this.confirmRedeem.text = items.name;
      items.user_mission_id = this.detail.data.user_mission_id;
      this.rewardItems = items;
      this.$refs.redeemConfirmModal.show();
    },
    rewardImage(items) {
      if (items.mission_detail_type_id == 5 && items.is_redeem == 1) {
        if (items.random_reward_type == 3) {
          return require("@/assets/images/point.png");
        }
        if (items.random_reward_type == 4) {
          return require("@/assets/images/Fail.png");
        }
        return (
          items.random_reward_url ||
          require("@/assets/images/default-image.png")
        );
      }
      if (items.mission_detail_type_id == 3) {
        return require("@/assets/images/point.png");
      }
      return items.image_url || require("@/assets/images/default-image.png");
    },
    showStamp(val) {
      val.mission_redeem_condition = this.detail.data.mission_redeem_condition;
      this.stampCondition = val;
      this.stampProduct = this.detail.data.select_product_detail || [];
      this.$refs.StampModal.show();
    },
    textStatus(id) {
      switch (id) {
        case "รอจัดส่ง":
          return "primary";
        case "รอกรอกข้อมูล":
          return "warning";
        case "รับที่ร้านค้า":
          return "primary";
        case "สำเร็จ":
          return "success";
        case "กำลังจัดเตรียมสินค้า":
          return "info";
        default:
          return "-";
      }
    },
    toggleReward() {
      this.expandRewards = !this.expandRewards;
    },
    toggleStamp() {
      this.isStampExpanded = !this.isStampExpanded;
    },
    async updateRedeemItems(va) {
      try {
        const payload = {
          ...this.rewardItems,
          branch_id: va || 0,
          user_mission_detail_id: this.rewardItems.id
        };

        this.$refs.modalLoading.show();

        const res = await this.$axios.put(
          "/api/v1/Mission/UpdateReward",
          payload
        );
        this.$refs.modalLoading.hide();

        if (res.result == 1) {
          this.$refs.ModalSelectBranch.close();
          if (this.rewardItems.is_redeem == 1) {
            this.$emit("refresh");
            return (this.successUpdateModal = true);
          }

          this.$router.push(
            `/mission-info/${this.rewardItems.mission_detail_id}/${this.missionId}`
          );
        } else {
          this.msg = res.message;
          this.$refs.modalError.show();
        }
      } catch (error) {
        this.msg = error.message;
        this.$logger({
          response: {
            config: { url: "/api/v1/Mission/UpdateReward", method: "POST" }
          },
          action: {
            action: "redeem profile mission error",
            id: 3,
            note: error.message
          }
        });
        this.$refs.modalError.show();
        this.$refs.modalLoading.hide();
      }
    },
    async useCoupon() {
      return await this.redeemItems(0);
    }
  }
};
</script>

<style scoped lang="scss">
.profile-mission-reward-panel {
  border-radius: 8px;
  // margin-top: 0.75rem;
}
.profile-mission-header {
  align-items: flex-start;
  display: flex;
  gap: 0.75rem;
  justify-content: space-between;
  padding: 0rem 0.25rem 0.75rem;
}
.profile-mission-stamp-grid {
  display: grid;
  gap: 0.75rem;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  padding: 0 0.25rem 0.75rem;
}
.profile-mission-stamp-btn {
  background: transparent;
  border: 0;
  display: flex;
  justify-content: center;
  padding: 0;
}
.profile-mission-stamp-img {
  width: min(100%, 50px);
}
.profile-mission-reward-row {
  align-items: flex-start;
  display: flex;
  gap: 0.75rem;
}
.profile-mission-reward-img {
  aspect-ratio: 1;
  border-radius: 50%;
  flex: 0 0 56px;
  width: 56px;
}
.profile-mission-reward-content {
  flex: 1;
  min-width: 0;
}
.text-nowrap {
  white-space: nowrap;
}
</style>
